module.exports = __webpack_public_path__ + "img/1524498995.64c969d1.jpg";